import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCupHot: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCupHot"><Path d="M8 2V6H6V2H8Z" fill="currentColor"/><Path d="M12 2V6H10V2H12Z" fill="currentColor"/><Path d="M16 6V2H14V6H16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18 7H4V22H18V16H18.5C20.433 16 22 14.433 22 12.5C22 10.567 20.433 9 18.5 9H18V7ZM18 11V14H18.5C19.3284 14 20 13.3284 20 12.5C20 11.6716 19.3284 11 18.5 11H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCupHot;
